module.exports = __webpack_public_path__ + "static/media/Git-logo.aaec9219.svg";